import React, { useEffect, useState } from "react";
import {
  Table,
  Badge,
  Dropdown,
  Button,
  Form,
  Row,
  Col,
  Container,
} from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import { MdDeleteForever, MdEdit } from "react-icons/md";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { formatDate } from "../../../helper/helper";
import {
  changeStatusApi,
  deleteUserApi,
} from "../../../hooks/ApisContainer/User";
import useToastContext from "../../../hooks/useToastContext";
import Swal from "sweetalert2";
import LottiLoader from "../../../components/shared/Loader/LottiLoader";

const TableList = ({ userData, setUser, fetchedGetUsers, pageLoader, currentPage, rowsPerPage }) => {
  const notification = useToastContext();
  const navigate = useNavigate();

  // ALL STATE
  const [loader, setLoader] = useState(false);

  const handleStatusChange = async (id, newStatus) => {
    const status = newStatus ? "active" : "inactive";
    const requestPayload = { status, id, type: "user" };

    changeStatusApi(requestPayload, notification, (loading, error) => {
      setLoader(loading);

      if (!error) {
        setUser((prevData) =>
          prevData.map((user) => (user._id === id ? { ...user, status } : user))
        );
        console.log("Status updated successfully");
      }
    });
  };

  const handelDelete = async (id) => {
    Swal.fire({
      text: "Are you sure you want to delete?",
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: "#ff6004",
      confirmButtonText: "Delete",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const requestPayload = { id };
          deleteUserApi(requestPayload, notification, (loading, error) => {
            setLoader(loading);

            if (!error) {
              console.log("User deleted successfully");
              fetchedGetUsers();
              setLoader(loading);
            }
          });
        } catch (error) {
          console.error("error:", error);
          setLoader(false);
        }
      }
    });
  };

  const handleShowModal = () => {
    alert("Coming Soon!!");
  };
  // console.log("userData", userData);
  return (
    <div className="card overflow-hidden all-tables">
      <div className="">
        <div className="table-responsive">
          <Table responsive="md" className="mb-0">
            <thead>
              <tr>
                <th>S.N</th>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile No</th>
                <th>Created At</th>
                <th>Status</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            {!pageLoader && userData?.length !== 0 && (
              <tbody>
                {userData &&
                  userData?.length > 0 &&
                  userData?.map((item, index) => {
                    return (
                      <tr>
                        <td>
                          <strong className="text-black">{(currentPage - 1) * rowsPerPage + index + 1}</strong>
                        </td>
                        <td>
                          {item?.firstName} {item.lastName}
                        </td>
                        <td>{item?.email}</td>
                        <td>{item?.mobile}</td>
                        <td>{formatDate(item?.createdAt)}</td>
                        <td>
                          <Form.Check // prettier-ignore
                            type="switch"
                            id="custom-switch"
                            checked={item?.status === "active"}
                            onChange={(e) =>
                              handleStatusChange(item?._id, e.target.checked)
                            }
                          />
                        </td>
                        <td className="text-center">
                          <div className="d-flex align-items-center justify-content-center">
                            {/* <Button
                            className="bg-transparent border-0 text-black fs-5 px-1"
                            onClick={() => handleShowModal()}
                          >
                            <MdEdit />
                          </Button> */}

                            <Link
                              to={`/member-view/${item?._id}`}
                              className="text-black fs-5 px-1"
                            >
                              <FaEye />
                            </Link>
                            <Link
                              to=""
                              className="text-danger fs-5 px-1"
                              onClick={() => handelDelete(item?._id)}
                            >
                              <MdDeleteForever />
                            </Link>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            )}

            {userData?.length < 0 && (
              <tbody>
                <tr className="text-center" colspan={7}>
                  <td colspan={7}>No Record Found</td>
                </tr>
              </tbody>
            )}
          </Table>

          {pageLoader && (
            <Container className="d-flex justify-content-center align-items-center default-back">
              <span>
                <LottiLoader height={120} width={120} loader={true} />
              </span>
            </Container>
          )}
        </div>
      </div>
    </div>
  );
};

export default TableList;
